import { Entity } from '@inter-ikea-core/core';
import { CoreApi, Product, ProductDesign } from '@inter-ikea-storageone/range';
import { getProductFromEntity } from 'rangeConfig/shared/utils/getProductFromEntity';
import replaceFrame from '../behaviours/replaceFrame';
import { store } from 'ducks';

export const changeSolutionColor = (
  coreApi: CoreApi,
  frames: Entity[],
  design: ProductDesign,
  products: Product[]
) => {
  let notReplaceableFrameFound = false;

  frames.forEach(frame => {
    const previousProduct = getProductFromEntity(frame, products, coreApi);

    if (!previousProduct) return;

    const matchingFrames = products.filter(
      product =>
        product.type === previousProduct.type &&
        product.communicatedDimensions.width === previousProduct?.communicatedDimensions.width &&
        product.communicatedDimensions.height === previousProduct?.communicatedDimensions.height &&
        product.communicatedDimensions.depth === previousProduct?.communicatedDimensions.depth
    );

    const nextFrame = matchingFrames.find(frame => frame.design === design);
    if (nextFrame) {
      replaceFrame({
        coreApi,
        rootState: store.getState(),
        props: { coreProductId: nextFrame.coreProductId },
        dispatch: store.dispatch,
        customFrame: frame
      });
    } else {
      notReplaceableFrameFound = true;
    }
  });
  return notReplaceableFrameFound;
};
